<h1 mat-dialog-title *ngIf="dialogData.header">{{dialogData.header}}</h1>
<mat-dialog-content>
  <div class="message-box flexContent flexColumn align-center gap-16">
    <mat-icon class="message-box__message-icon theme-icon theme-icon--light-warning">
      {{dialogData.iconText}}
    </mat-icon>
    <div class="message-box__message-text">
      {{dialogData.message}}
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="" mat-stroked-button (click)="cancelButtonClick()">
    <span class="action-button">
      {{dialogData.cancelButtonText}}
    </span>
  </button>
  <button class="theme-button--light-blue" mat-button cdkFocusInitial (click)="confirmButtonClick()">
    <span class="action-button px-10 ">
      {{dialogData.confirmButtonText}}
    </span>
  </button>
</mat-dialog-actions>